// extracted by mini-css-extract-plugin
export default {"heading":"Vt-z","corrected":"Wt-z","redirectVerbiageContainer":"Xt-z","redirectVerbiageText":"Yt-z"};